"use strict";
import 'bootstrap/js/dist/tooltip';

export function initInScope($scope) {
    $scope.find('.js-dropdown-cart-tooltip').tooltip();
    $scope.find('.js-tooltip').tooltip();
}
